module.exports = __webpack_public_path__ + "assets/f5-bigip.27257ad9.svg";